import {css, Theme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {calculateRemSize, flexJustifyCenter, maxWidth, mb, onDesktop, pl, position, w66, w100} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

const headerXl = require("../images/credit-header-2560.png");
const headerLg = require("../images/credit-header-1920.png");
const headerMd = require("../images/credit-header-1366.png");
const headerSm = require("../images/credit-header-600.png");
const headerXs = require("../images/credit-header-360.png");

export const CreditCalculatorHeader = () => {
    return (
        <div css={headerWrapper}>
            <Picture
                sources={[
                    {minWidthPX: 0, src: headerXs, height: 525, width: 360},
                    {minWidthPX: 360, src: headerSm, height: 525, width: 600},
                    {minWidthPX: 600, src: headerMd, height: 525, width: 1366},
                    {minWidthPX: 1367, src: headerLg, height: 525, width: 1920},
                    {minWidthPX: 1921, src: headerXl, height: 525, width: 2560}
                ]}
                alt="header"
                fit="right"
            />
            <div css={headerGradient} />

            <Container css={headerContentPositioner}>
                <div css={headerTexts}>
                    <Text variant="headline_1" fontFamily="secondary" css={[fontWeight400, mb(2), onDesktop(mb(5))]}>
                        Kredyt hipoteczny z <br />
                        rynekpierwotny.pl
                    </Text>
                    <Text variant="headline_3" as="h2" css={[mb(2), onDesktop(mb(5))]}>
                        Przeprowadzimy Cię przez kredyt na wymarzone M
                    </Text>

                    <Text variant="body_copy_0" className="body_copy">
                        Kredyt hipoteczny to jedna z najważniejszych decyzji w drodze po własne M. Podejmij decyzję świadomie i skorzystaj z kalkulatorów
                        zdolności kredytowej oraz raty kredytu, a także rankingu kredytów hipotecznych zgodnych z Twoimi możliwościami
                    </Text>
                </div>
            </Container>
        </div>
    );
};

const headerWrapper = css`
    ${position("relative")};
    ${flexJustifyCenter};
    height: 525px;
`;

const headerGradient = (theme: Theme) => css`
    @media (max-width: ${theme.breakpoints.md}) {
        position: absolute;
        inset: 0;
        background: linear-gradient(to left, transparent, ${theme.colors.gray[500]});
    }
`;

const headerContentPositioner = css`
    position: absolute;
    top: ${calculateRemSize(6)};
    ${w100};

    ${onDesktop(css`
        top: ${calculateRemSize(4)};
    `)};
`;

const headerTexts = (theme: Theme) => css`
    ${maxWidth("685px")};

    .body_copy {
        ${maxWidth("465px")};
    }

    @media (min-width: 525px) {
        ${w66};
    }
    @media (min-width: ${theme.breakpoints.md}) {
        width: unset;
    }
    @media (min-width: ${theme.breakpoints.lg}) {
        ${pl(4)};
    }
`;

export const fontWeight400 = css`
    font-weight: 400;
`;
import {css, Theme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {calculateRemSize, flexJustifyCenter, maxWidth, mb, onDesktop, pl, position, w66, w100} from "@pg-design/helpers-css";
import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";

const headerXl = require("../images/credit-header-2560.png");
const headerLg = require("../images/credit-header-1920.png");
const headerMd = require("../images/credit-header-1366.png");
const headerSm = require("../images/credit-header-600.png");
const headerXs = require("../images/credit-header-360.png");

export const CreditCalculatorHeader = () => {
    return (
        <div css={headerWrapper}>
            <Picture
                sources={[
                    {minWidthPX: 0, src: headerXs, height: 525, width: 360},
                    {minWidthPX: 360, src: headerSm, height: 525, width: 600},
                    {minWidthPX: 600, src: headerMd, height: 525, width: 1366},
                    {minWidthPX: 1367, src: headerLg, height: 525, width: 1920},
                    {minWidthPX: 1921, src: headerXl, height: 525, width: 2560}
                ]}
                alt="header"
                fit="right"
            />
            <div css={headerGradient} />

            <Container css={headerContentPositioner}>
                <div css={headerTexts}>
                    <Text variant="headline_1" fontFamily="secondary" css={[fontWeight400, mb(2), onDesktop(mb(5))]}>
                        Kredyt hipoteczny z <br />
                        rynekpierwotny.pl
                    </Text>
                    <Text variant="headline_3" as="h2" css={[mb(2), onDesktop(mb(5))]}>
                        Przeprowadzimy Cię przez kredyt na wymarzone M
                    </Text>

                    <Text variant="body_copy_0" className="body_copy">
                        Kredyt hipoteczny to jedna z najważniejszych decyzji w drodze po własne M. Podejmij decyzję świadomie i skorzystaj z kalkulatorów
                        zdolności kredytowej oraz raty kredytu, a także rankingu kredytów hipotecznych zgodnych z Twoimi możliwościami
                    </Text>
                </div>
            </Container>
        </div>
    );
};

const headerWrapper = css`
    ${position("relative")};
    ${flexJustifyCenter};
    height: 525px;
`;

const headerGradient = (theme: Theme) => css`
    @media (max-width: ${theme.breakpoints.md}) {
        position: absolute;
        inset: 0;
        background: linear-gradient(to left, transparent, ${theme.colors.gray[500]});
    }
`;

const headerContentPositioner = css`
    position: absolute;
    top: ${calculateRemSize(6)};
    ${w100};

    ${onDesktop(css`
        top: ${calculateRemSize(4)};
    `)};
`;

const headerTexts = (theme: Theme) => css`
    ${maxWidth("685px")};

    .body_copy {
        ${maxWidth("465px")};
    }

    @media (min-width: 525px) {
        ${w66};
    }
    @media (min-width: ${theme.breakpoints.md}) {
        width: unset;
    }
    @media (min-width: ${theme.breakpoints.lg}) {
        ${pl(4)};
    }
`;

export const fontWeight400 = css`
    font-weight: 400;
`;
